import { Link } from '@/i18n/navigation';
import SvgLogo from './svg/SvgLogo';

export default function Logo() {
    return (
        <div className="hidden xl:block py-7">
            <Link href="/" className="inline-flex text-purple-800">
                <SvgLogo width="166" height="26" />
            </Link>
        </div>
    );
}
